import { render, staticRenderFns } from "./CoverageAmountHelpDialog.vue?vue&type=template&id=6004ca34&scoped=true"
import script from "./CoverageAmountHelpDialog.vue?vue&type=script&lang=js"
export * from "./CoverageAmountHelpDialog.vue?vue&type=script&lang=js"
import style0 from "./CoverageAmountHelpDialog.vue?vue&type=style&index=0&id=6004ca34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6004ca34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VDivider,VIcon,VSpacer})
